import React, { useEffect, useState } from 'react';
import { random } from 'lodash';
import callApi from '../../../../../util/apiCaller';
import { generateRequestId, showNotification } from '../../../../../util/utility';
import { fetchUserProfile, loginInvestorUser, loginUser } from '../../../../App/AppActions';
import { useDispatch } from 'react-redux';
import PageLoader from '../../../../../components/loader/PageLoader';
import { captureMessagesViaErrorLogger } from '../../../../../util/errorLogger';
import storage from '../../../../../util/storageService';
import { useNavigate } from 'react-router';
import { loginHelper } from '../../../common/apiHelpers';

function GoogleSignIn(props) {
    const navigate = useNavigate();
    const requestId = sessionStorage.getItem('requestId');
    const [toRenderOrNot, setToRenderOrNot] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    // const [googleText, setText] = useState(" ")
    const clientId = '256880191997-in5gvdsu6n4oe9vrok3i2a8g4ok76j7j.apps.googleusercontent.com';
    const onSignIn = () => {
        const authInstance = window?.gapi?.auth2?.getAuthInstance();
        const users = authInstance.currentUser.get();
        const profile = users.getBasicProfile();
        const id_token = users.getAuthResponse().id_token;
        const password = `${profile?.getEmail()}${+new Date()}`; //creating password for the user if not exist for baward compatiblity with Login api
        const user = {
            name: profile.getName(),
            emailId: profile.getEmail(),
            userType: 'Investee',
        };
        if (props.signUp && user.name) {
            //If the component is rendered from signup side
            // setText("Sign up with Google")
            const obj = {
                mfaValidationToken: id_token,
                workspaceRoute: true,
                user: user,
                requestId: requestId ? requestId : generateRequestId(),
            };
            //Redirect to get-started page
            navigate('/signup/get-started', { state: { obj: obj, password: password } });
        } else if (props.logIN) {
            // If the component is rendered from the login side
            // setText("Login With Google")
            dispatch(
                loginUser({
                    user: user,
                    mfaValidationToken: id_token,
                    requestId: requestId ? requestId : generateRequestId(),
                    workspaceRoute: true,
                    incomingQuery: localStorage.getItem('incomingQueryLogin') ?? '',
                }),
            );
        } else if (props.investor) {
            dispatch(
                loginInvestorUser({
                    user: { ...user, userType: 'Investor' },
                    mfaValidationToken: id_token,
                    requestId: requestId ?? generateRequestId(),
                    workspaceRoute: true,
                }),
            );
        }
    };
    const onFailure = () => {};
    const renderSigninGoogleButton = () => {
        window.gapi.load('auth2', () => {
            // Load Google Sign-In API
            window.gapi.auth2
                .init({
                    clientId: clientId,
                    scope: 'https://www.googleapis.com/auth/business.manage',
                    immediate: true,
                })
                .then(() => {
                    setIsLoading(false);
                })
                .catch((err) => {
                    if (
                        err.details.includes('Cookies') &&
                        err.details.includes('not') &&
                        err.details.includes('environment')
                    ) {
                        captureMessagesViaErrorLogger('Failed to google Signin: ' + err.details);
                        setToRenderOrNot(false);
                        setIsLoading(false);
                    }
                });
            window.gapi.load('signin2', () => {
                // Load Google Sign-In Button
                window.gapi.signin2.render('google-signin-btn', {
                    scope: 'https://www.googleapis.com/auth/business.manage',
                    height: 40,
                    width: 100,
                    longtitle: true,
                    theme: 'dark',
                    onsuccess: onSignIn,
                    onfailure: onFailure,
                });
            });
        });
    };

    const insertGapiScript = () => {
        const script = document.createElement('script');
        script.src = 'https://apis.google.com/js/platform.js';
        script.onload = () => {
            renderSigninGoogleButton();
        };
        script.async = true;
        document.body.appendChild(script);
    };

    useEffect(() => {
        insertGapiScript();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!toRenderOrNot) {
            document.getElementById('google-signin-btn').remove();
        }
    }, [toRenderOrNot]);
    return (
        <>
            {isLoading && <PageLoader />}
            <div id="google-signin-btn" style={{ width: '100% !important' }}></div>
        </>
    );
}

export default GoogleSignIn;
